import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

export default function SchoolAddressStep({ formData, setFormData }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <h2>{t("Start.schoolAddress")}</h2>
      <input
        ref={inputRef}
        type="text"
        value={formData.schoolAddress}
        onChange={e =>
          setFormData({ ...formData, schoolAddress: e.target.value })
        }
      />
    </>
  );
}
